<div class="flex flex-column gap-2">
  <div class="basis-1/2">
    <nx-table-header class="text-[1rem]" [label]="'coreModuleModule.customAttributesComponent.table.title' | translate">
      <ng-template nxTemplate="end">

      </ng-template>
    </nx-table-header>
    <p-table
      #httpLogTable
      [lazy]="true"
      [value]="entityTypes | translateLabels"
      [scrollable]="true"
      [paginator]="false"
      selectionMode="single" 
      [(selection)]=selectedEntityType
      (onRowSelect)="loadCustomAttributeSections()"
      [resizableColumns]="false">
      <ng-template pTemplate="header">
        <tr >
            <th style="width: auto;;">Name</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-entityType>
        <tr class="clickable" [pSelectableRow]="entityType">
          <td>{{entityType?.name}}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="8" class="emptyMessage">Keine Entitytypen vorhanden.</td>
        </tr>
      </ng-template>
    </p-table>
    <ng-template pTemplate="footer">
    </ng-template>
  </div>
  <div class="basis-1/2">
    <nx-headline-box
      [label]="selectedEntityType ? selectedEntityType?.name : '-'">
      <ng-template nxTemplate="end">
        <nx-default-button
          *ngIf="selectedEntityType"
          [label]="'Section hinzufügen'"
          [style]="'light'"
          (click)="addCustomAttributeSection()"
          [icon]="'icon-plus'">
        </nx-default-button>
      </ng-template>
    </nx-headline-box>
    <nx-empty-box
      *ngIf="!selectedEntityType"
      label="coreModuleModule.customAttributesComponent.entityType.emptyMessage">
      </nx-empty-box>
    <nx-empty-box
      *ngIf="selectedEntityType && !customAttributeSections?.length"
      label="coreModuleModule.customAttributesComponent.customAttributeSections.emptyMessage">
      </nx-empty-box>
    <ng-container
      *ngFor="let section of customAttributeSections">
      <app-custom-attribute-section
        (refetch)="loadCustomAttributeSections()"
        [customAttributeSections]="customAttributeSections"
        [customAttributeSection]="section">
      </app-custom-attribute-section>
    </ng-container>

  </div>
</div>